import type { ReactNode } from 'react'

export interface EmptyStateProps {
  title: string
  body?: string
  action?: ReactNode
}

/**
 * EmptyState — what a list shows when it has nothing.
 *
 * A design surface, not an oversight. Callers are expected to distinguish
 * "nothing here yet" (offer creation) from "nothing matched your filter"
 * (offer clearing it) — conflating the two produces the daily friction of
 * being told to create a record that already exists behind a filter.
 */
export function EmptyState({ title, body, action }: EmptyStateProps) {
  return (
    <div className="lg-empty">
      <p className="lg-empty__title">{title}</p>
      {body && <p className="lg-empty__body">{body}</p>}
      {action}
    </div>
  )
}
